// Generated by GitHub Copilot
import { CompanyTimestampedModel } from '#core/entities/shared/BaseModels.ts'

/** A general-purpose tag that can be assigned to one or more parts. */
export default class PartTag extends CompanyTimestampedModel {
  value = ''
  description: string | null = null
  color: string | null = null
  icon: string | null = null
  order: number | null = null
}
